<script>
    export let ticketsSize = 0
    export let order =  'asc'//, 'desc'
    export let needReplyFromAdmin = true
    export let startAtDate = new Date(0)

    import firebase from "firebase/app"
    import "firebase/firestore"
    import { getContext } from 'svelte'

    const userRole = getContext("userRole")

    let tickets = [
        // {important: true, header: "Ticket header #1", creationTime: firebase.firestore.Timestamp.fromDate(new Date()), id: "k4RohmGXRkTvV2xXVkwd"},
        // {important: false, header: "Ticket header #2", creationTime: firebase.firestore.Timestamp.fromDate(new Date()), id: "k4RohmGXRkTvV2xXVkwd"},
        // {important: false, header: "Ticket header #3", creationTime: firebase.firestore.Timestamp.fromDate(new Date()), id: "k4RohmGXRkTvV2xXVkwd"},
        // {important: true, header: "    Ticket header #4 Ticket Ticket header #4    Ticket header #4 Ticket ", creationTime: firebase.firestore.Timestamp.fromDate(new Date()), id: "k4RohmGXRkTvV2xXVkwd"},
    ]

    let unsubscribe
    $: {
        if (unsubscribe) {
            unsubscribe()
        }
        unsubscribe = firebase.firestore().collection("HelpDeskTickets")
                                        .where("needReplyFromAdmin", "==", needReplyFromAdmin)
                                        .orderBy('creationTime', order)
                                        .startAt(firebase.firestore.Timestamp.fromDate(startAtDate))
                                        .limit(100)
                                        .onSnapshot(querySnapshot => {
            //console.log(`Received tickets query snapshot of size ${querySnapshot.size}`)
            ticketsSize = querySnapshot.size
            tickets = querySnapshot.docs.map((ticket) => {
                //console.debug("ticket", ticket.id, ticket.data())
                return {...ticket.data(), id: ticket.id}
            })
        }, err => {
            console.log(`Encountered error: ${err}`)
            //alert(err)
        })
    }

    function closeTicket(ticket) {
        const ticketDoc = firebase.firestore().collection("HelpDeskTickets").doc(ticket.id)
        ticketDoc.update({ needReplyFromAdmin: false })
    }
    
    function deleteTicket(ticket) {
        //console.log("Try to delete:", ticket.id)
        const ticketDoc = firebase.firestore().collection("HelpDeskTickets").doc(ticket.id)
        ticketDoc.delete().then(() => {
            //console.log("Document successfully deleted!")
        }).catch((error) => {
            console.error("Error removing document: ", error)
        });
    }
</script>


<table class="highlight" >
    <thead>
        <tr>
            <th></th>
            <th>Header</th>
            <th>Creation time</th>
            <th>Modification time</th>
            {#if needReplyFromAdmin}
            <th></th>
            {/if}
        </tr>
    </thead>

    <tbody>
        {#each tickets as ticket}
            <tr on:click={(e) => window.location.href = "/#/Ticket/" + ticket.id}>
                <td class="ticket-importance">
                    {#if ticket.important}
                        <i class="material-icons tiny red-text">warning</i>
                    {/if}
                </td>
                <td class="ticket-header">{ticket.header}</td>
                <td class="ticket-time">{ticket.creationTime.toDate().toLocaleString()}</td>
                <td class="ticket-time">{Number(ticket.modificationTime) !== Number(ticket.creationTime) ? ticket.modificationTime.toDate().toLocaleString() : "-"}</td>
                <td>
                    {#if userRole == "Writer"}
                        {#if needReplyFromAdmin} 
                            <div on:click={ (event) => { event.stopPropagation(); closeTicket(ticket) }}>
                                <i class="material-icons delete-icon">close</i>
                            </div>
                        {:else}
                            <div on:click={ (event) => { event.stopPropagation(); deleteTicket(ticket) }}>
                                <i style="font-size: 16px; color: red" class="material-icons delete-icon">delete</i>
                            </div>
                        {/if}
                    {/if}
                </td>
            </tr>
        {/each}
    </tbody>
</table>


<style>
    .ticket-importance {
        width: 5%;
        user-select: none;
    }
    .ticket-header {
        width: 65%;
        user-select: none;
    }
    .ticket-time {
        width: 15%;
        font-style: italic;
        color: grey;
        user-select: none;
    }
    .delete-icon {
        color: grey;
        user-select: none;
    }
    .delete-icon:hover {
        color: black;
    }
</style>